import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';
import modalSelectClient from '../shared/components/modal-select-client/modal-select-client.view.html';
import modalSelectBranch from '../login/modal-select-branch-b2b-user/modal-select-branch-b2b-user.view.html';
import createPQRSModal from '../pqrs/pqrs-form-modal/pqrs-form-modal.view.html';
let inject = [
    '$scope',
    '$state',
    '$rootScope',
    'SharedService',
    '$mdSidenav',
    '$timeout',
    'ngAuthSettings',
    '$mdDialog',
    'SessionService'
];

class HeaderCoreController {
    constructor($scope,
                $state,
                $rootScope,
                SharedService,
                $mdSidenav,
                $timeout,
                ngAuthSettings,
                $mdDialog,
                SessionService
    ) {
        this.$state = $state;
        this.SessionService = SessionService;
        this.$mdSidenav = $mdSidenav;
        this.ngAuthSettings = ngAuthSettings;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.SharedService = SharedService;
        this.$mdDialog = $mdDialog;
        this.message = "Bienvenidos al header";
        this.toggleLeft = this.buildToggler('left');
        this.cartUnified = false;
        this.pageName = "PAG-2";
        this.SharedService.getCMSBanners(this.pageName, __env.adaptative ? 1:0).then(response => {
            this.cmsData = response;
        });
        this.eltemplo=  __env.clientName == 'eltemplo' ? true : false;
        this.activateSearch = true;
        this.$rootScope.$on('onChangeCompany', (event, arg) => {
            event.stopPropagation();
            this.SharedService.getCMSBanners(this.pageName, __env.adaptative ? 1:0,arg).then(response => {
                this.cmsData = response;
            });
        });

    }

    $onInit() {

        this.cartUnified = this.SessionService.get('cartUnified');
        this.logoLink = "./assets/sitios/" + __env.clientName + "/img/proyect-selected/logo-header.png"
        if (this.cartUnified) {
            if(__env.adaptative){
              var aceptInfoCart = this.aceptInfoCart();
              var confirm = this.$mdDialog.confirm()
                .title('Carrito unificado')
                .textContent('Los ítems del carrito se han unificado con un carrito que ya tenia creado anteriormente.')
                .ok('Aceptar')

              this.$mdDialog.show(confirm).then(function() {
                  window.scrollTo(0, 0);
                aceptInfoCart();
              });
            }
            this.$timeout(() => {
                this.aceptInfoCart();
            }, 10000);
        }

        if(__env.adaptative){
            this.topToolbarSticky();
        }

    }

    buildToggler(componentId) {
        return function () {
            this.$mdSidenav(componentId).toggle();
        };
    }


    globalSearchTextHome(data) {
        let elementInput = document.getElementById("globalSearchTextHome");
        let closedSearch = document.getElementById("closedSearch");

        elementInput.classList.add("expanded");
        elementInput.focus();
        closedSearch.classList.add("visible");
    }

    closed() {
        let elementInput = document.getElementById("globalSearchTextHome");
        elementInput.classList.remove("expanded");
        closedSearch.classList.remove("visible");
        this.shCtrl.globalSearchTextHome = null;
    }

    clearSearch() {
        this.shCtrl.globalSearchTextHome = null;
    }

    bookDate() {
        this.formDate = !this.formDate;

    }

    aceptInfoCart() {
        this.SessionService.remove('cartUnified');
        this.cartUnified = false;
    }


    topToolbarSticky() {
      /*const filterBar = document.querySelector('#topToolbar');
      const sticky = filterBar.offsetTop;

      function stickyFilter() {
        if (window.scrollY >= 10) {
          filterBar.classList.add("sticky--top");
        } else {
          filterBar.classList.remove("sticky--top");
        }
      }
      window.addEventListener('scroll', stickyFilter);*/
    }

    showSearch(){

        this.activateSearch = !this.activateSearch;

    }

}

HeaderCoreController.$inject = inject;

export default HeaderCoreController;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/header-core/header-core.controller.js
 **/